var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.999 511.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.999 423.723H8.828A8.829 8.829 0 0 1 0 414.895V97.103a8.829 8.829 0 0 1 8.828-8.828H256v335.448h-.001z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.999 88.276h247.172a8.829 8.829 0 0 1 8.828 8.828v317.792a8.829 8.829 0 0 1-8.828 8.828H255.999V88.276z",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.608 223.906l-15.305 20.021-23.897-7.999c-1.336-.447-2.473 1.064-1.673 2.223l14.312 20.743-14.993 20.256c-.839 1.132.247 2.68 1.598 2.277l24.15-7.202 14.632 20.519c.818 1.148 2.626.593 2.66-.815l.613-25.194 24.035-7.575c1.344-.424 1.375-2.314.046-2.782l-23.77-8.369.223-25.201c.013-1.408-1.776-2.021-2.631-.902z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.866 316.629c-33.459 0-60.6-27.141-60.6-60.63 0-33.428 27.141-60.63 60.6-60.63 12.448 0 23.928 3.829 33.495 10.308 1.465.992 3.137-.932 1.91-2.208-14.298-14.866-34.535-23.934-56.971-23.168-38.548 1.315-70.459 32.222-72.922 70.713-2.822 44.089 32.089 80.728 75.554 80.728 21.41 0 40.652-8.951 54.393-23.262 1.214-1.265-.462-3.16-1.912-2.177-9.578 6.493-21.077 10.326-33.547 10.326z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/dz.58ec8a752e2506362d05ea1ac42d19cd.svg";
export { ForwardRef as ReactComponent };